// This file is generated by utils/generate_icons.ts. Do not edit by hand.

export const iconNames = [
  'Svg2022_uad_comment',
  'Svg2022_uad_comment_add',
  'Svg2022_uad_comment_reply',
  'Svg2022_uad_metadata',
  'Svg2022_uad_subclip',
  'Svg2022_uad_subclip_add',
  'Svg2022_uad_time_based_metadata',
  'Svg2022_uad_timebased_metadata_add',
  'academy',
  'access_control',
  'ai',
  'ai_2',
  'ai_metadata',
  'ai_search',
  'analyze',
  'annotation_activate',
  'annotation_annotation',
  'annotation_arrow',
  'annotation_brush',
  'annotation_brushsize',
  'annotation_circle',
  'annotation_color_palette',
  'annotation_de_activate',
  'annotation_erase',
  'annotation_eraser',
  'annotation_laser',
  'annotation_line',
  'annotation_move',
  'annotation_pencil',
  'annotation_rectangle',
  'annotation_redo',
  'annotation_text',
  'annotation_undo',
  'archive_archive',
  'archive_archived',
  'archive_restore',
  'arrow_small_e',
  'arrow_small_n',
  'arrow_small_s',
  'arrow_small_w',
  'aspect_ratio',
  'asset_delete',
  'asset_type_audio',
  'asset_type_image',
  'asset_type_pdf',
  'asset_type_placeholder',
  'asset_type_subclip',
  'asset_type_unknown',
  'asset_type_video',
  'attachment',
  'automations',
  'background',
  'bell_crossed',
  'broom',
  'calendar',
  'calendar_datetime',
  'checkmark',
  'chevron_large_isolated_e',
  'chevron_large_isolated_n',
  'chevron_large_isolated_s',
  'chevron_large_isolated_w',
  'chevron_small_isolated_e',
  'chevron_small_isolated_n',
  'chevron_small_isolated_s',
  'chevron_small_isolated_w',
  'child',
  'close',
  'cluster',
  'collection',
  'collection_add_to',
  'collection_create_new',
  'collection_opened',
  'comment',
  'comment_hidden',
  'company_dailymotion',
  'company_discord',
  'company_dropbox',
  'company_facebook',
  'company_instagram',
  'company_snapchat',
  'company_tiktok',
  'company_twitch',
  'company_twitter',
  'company_we_transfer',
  'company_x',
  'company_youtube',
  'compare',
  'conversation',
  'copy',
  'credit',
  'custom_action',
  'deletion_clear',
  'deletion_delete',
  'deletion_erase',
  'deletion_remove',
  'destination',
  'dev_api',
  'display_hide',
  'display_show',
  'divide',
  'drag',
  'edit',
  'email',
  'email_error',
  'emoji',
  'enter',
  'face_recognition',
  'fail',
  'favorite_assets',
  'favorite_collections',
  'favorite_saved_searches',
  'favorites_add_to',
  'favorites_added_to',
  'file',
  'file_export',
  'file_proxy',
  'filter',
  'fit_actual_size',
  'fit_height',
  'fit_viewport',
  'fit_width',
  'folder',
  'fr_change_person',
  'gallery',
  'globe',
  'go_to',
  'help_description',
  'help_tooltip',
  'history',
  'home',
  'iconik_agent_icon',
  'iconik_shield',
  'id',
  'image_add',
  'index_icon',
  'ip_address',
  'isg',
  'isg_pro',
  'jobs',
  'key',
  'keyboard',
  'language',
  'layout',
  'link',
  'link_add',
  'load_down',
  'load_up',
  'loader_circle_done_legacy',
  'log_in',
  'log_out',
  'megaphone',
  'mention',
  'menu_context',
  'menu_hamburger',
  'message_error',
  'message_success',
  'message_warning',
  'metadata_dropdown',
  'metadata_float',
  'metadata_integer',
  'metadata_text',
  'metadata_text_area',
  'minus',
  'money_billing',
  'money_credit_card',
  'money_invoice',
  'money_top_up',
  'money_transaction',
  'money_wallet',
  'moon',
  'move',
  'move_bottom',
  'move_top',
  'node',
  'not_modified',
  'notification',
  'open',
  'padlock_locked',
  'padlock_unlocked',
  'page_first_horizontally',
  'page_last_horizontally',
  'page_number',
  'pages',
  'pending',
  'pin',
  'player_flip_horizontally',
  'player_flop_vertically',
  'player_loop',
  'player_loop_pingpong',
  'player_marker',
  'player_mixer',
  'player_pan',
  'player_pause',
  'player_play',
  'player_playback_options',
  'player_playback_speed',
  'player_time_format',
  'player_view_full',
  'player_view_normal',
  'player_volume_max',
  'player_volume_meter',
  'player_volume_mid',
  'player_volume_no',
  'player_zoom_in',
  'player_zoom_out',
  'playlist',
  'plus',
  'portal',
  'portal_new',
  'poster',
  'present',
  'printer',
  'project',
  'protected',
  'ra',
  'ra_approval_requested',
  'ra_approval_requested_to_me',
  'ra_approval_requested_to_me_v2',
  'ra_approved',
  'ra_approved_by_me',
  'ra_rejected',
  'ra_rejected_by_me',
  'range_in_point',
  'range_out_point',
  'range_range',
  'recent',
  'recent_assets',
  'recent_collections',
  'refresh',
  'relations',
  'reorder',
  'reply',
  'reset',
  'revert',
  'role_groups',
  'rotate_clockwise',
  'rotate_counter_clockwise',
  'saved_search',
  'search',
  'segment_go_to',
  'selection_items',
  'selection_items_all',
  'selection_text',
  'send',
  'sequence',
  'settings',
  'share',
  'share_by_me',
  'share_with_me',
  'sidebar_below',
  'sidebar_right',
  'smartphone',
  'snapshot',
  'sort',
  'sort_newest',
  'sort_oldest',
  'star_fill',
  'statistics',
  'status_generic',
  'storage_cloud',
  'storage_on_premise',
  'subtitles',
  'sum',
  'sun',
  'sync',
  'sync_paused',
  'tag',
  'tasks',
  'tasks_canceled',
  'terms',
  'text_blockquote',
  'text_bold',
  'text_editor',
  'text_italic',
  'text_list_bullet',
  'text_list_number',
  'text_strikethrough',
  'text_underscore',
  'tier_enterprise',
  'toggle_on',
  'transcoder',
  'transcription',
  'transfer',
  'translucent',
  'transparency',
  'upgrade',
  'user_add',
  'user_group',
  'user_type_browse',
  'user_type_power',
  'user_type_standard',
  'user_user',
  'versions',
  'versions_add_new',
  'video_highlight',
  'view_grid',
  'view_list',
  'webhook',
] as const;

export type IconName = (typeof iconNames)[number];
